module.exports = "<label class=\"get-date-style\">\r\n  {{ getDateTime() }}\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/get-date-time/get-date-time.component.html
// module id = 2333
// module chunks = 66